import React from "react";
import { useStyles } from "./styles";

const StudentLeaveDescription = ({ showIcon, icon, description, styles }) => {
  const classes = useStyles();
  return (
    <div className={classes.descriptionContainer} style={styles}>
      {showIcon && (
        <img
          src={icon}
          alt="icon"
          style={{
            width: "24px",
            height: "24px",
            marginRight: "8px",
          }}
        />
      )}
      <p className={classes.description}>{description}</p>
    </div>
  );
};

export default StudentLeaveDescription;
